var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 392,
    viewBox: "0 0 165 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.1691,
    cy: 303.512,
    r: 36.6899,
    transform: "rotate(30 37.1691 303.512)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 0.492029 305.56)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 46.5995 268.203)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-125.42 300.507C-61.4634 337.432 20.3175 315.519 57.2429 251.563C94.1682 187.606 72.2551 105.825 8.29853 68.8997C-55.658 31.9744 -137.439 53.8875 -174.364 117.844C-211.29 181.801 -189.377 263.582 -125.42 300.507ZM-125.92 301.373C-61.4851 338.574 20.9074 316.497 58.1089 252.063C95.3104 187.628 73.2334 105.235 8.79853 68.0337C-55.6363 30.8322 -138.029 52.9092 -175.23 117.344C-212.432 181.779 -190.355 264.171 -125.92 301.373Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesContact);
export default __webpack_public_path__ + "static/media/circles_contact.9a1e23e47e5d5aa66174f2468c94e3d5.svg";
export { ForwardRef as ReactComponent };